import React from 'react';
import Icon from 'wonderbly-components/lib/Icon';
import PropTypes from 'prop-types';
import { CaretRight } from '../../SVGs';
import NavItemContent from './NavItemContent';

import './NavItem.scss';

// In Prismic (Navigation v2), these are Link to the Web.
const AbsoluteLinkTag = ({
  href,
  title,
  icon,
  iconColor,
  badgeText,
}) => {
  return (
    <a
      className="nav-item__link"
      href={href}>
      <NavItemContent
        title={title}
        icon={icon}
        iconColor={iconColor}
        badgeText={badgeText}
      />
    </a>
  );
};

AbsoluteLinkTag.propTypes = {
  ...NavItemContent.propTypes,
  href: PropTypes.string,
  title: PropTypes.string.isRequired,
};

// In Prismic (Navigation v2), these are links to internal content
// (e.g. dynamic layout, etc).
const RelativeLinkTag = ({
  href,
  title,
  icon,
  iconColor,
  badgeText,
  onClick,
  isInRoute,
}) => href ? (
  <a
    className="nav-item__link"
    href={href}>
    <NavItemContent
      title={title}
      icon={icon}
      iconColor={iconColor}
      badgeText={badgeText}
    />
  </a>
) : (
  <button
    className="nav-item__link"
    onClick={onClick}>
    <NavItemContent
      title={title}
      icon={icon}
      iconColor={iconColor}
      badgeText={badgeText}
    />
    <div className="nav-item__arrow-vertical">
      <Icon icon={isInRoute ? 'directup' : 'dropdown'} />
    </div>
    <div className="nav-item__arrow-right">
      <CaretRight />
    </div>
    {isInRoute && (
      <div className="nav-item__expand-arrow" />
    )}
  </button>
);

RelativeLinkTag.propTypes = {
  ...NavItemContent.propTypes,
  href: PropTypes.string,
  title: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  isInRoute: PropTypes.bool,
};

export { AbsoluteLinkTag, RelativeLinkTag };
